module.exports = __webpack_public_path__ + "static/media/close-k-24.238ae811.png";